const userManage = {
  site: {
    zh: '网点',
    en: '',
    pu: 'Ponto der Rede'
  },
  pleaseCheckSite: {
    zh: '请选择站点',
    en: '',
    pu: 'favor selecionar o ponto'
  },
  confirmCheck: {
    zh: '确定同意审核？',
    en: '',
    pu: 'Tem certeza de concordar em rever?'
  },
  AuditSuccess: {
    zh: '审核成功',
    en: '',
    pu: 'Revisão bem-sucedida'
  },

  importSuccessNotErr: {
    zh: '导入成功无错误数据',
    en: '',
    pu: 'Importar dados com sucesso sem dados errados'
  },
  state: {
    zh: '状态',
    en: 'state',
    pu: 'status'
  },
  accountState: {
    zh: '状态：',
    en: 'state',
    pu: 'status'
  },
  all: {
    zh: '全部',
    en: 'all',
    pu: 'Todos'
  },
  enable: {
    zh: '启用',
    en: 'enable',
    pu: 'Ativar'
  },
  Disable: {
    zh: '停用',
    en: 'Disable',
    pu: 'Desativar'
  },
  realName: {
    zh: '名称',
    en: 'name',
    pu: 'Nome'
  },
  username: {
    zh: '账户名',
    en: '',
    pu: 'nome da conta'
  },
  phone: {
    zh: '电话',
    en: 'Phone',
    pu: 'Telefone'
  },
  roleId: {
    zh: '角色',
    en: '',
    pu: 'papel'
  },
  userPhone: {
    zh: '电话',
    en: 'Phone',
    pu: 'Telefone'
  },
  name: {
    zh: '名称',
    en: 'name',
    pu: 'nome'
  },
  roleName: {
    zh: '角色',
    en: '',
    pu: 'papel'
  },
  Null: {
    zh: '暂无',
    en: 'No',
    pu: 'Não'
  },
  userNameL: {
    zh: '账户名',
    en: '',
    pu: 'nome da conta'
  },
  CollapseQuery: {
    zh: '收起查询',
    en: 'Collapse the Query button',
    pu: 'Recolher o botão Consulta'
  },
  ExpandQuery: {
    zh: '展开查询',
    en: 'Expand the Query button',
    pu: 'Expandir o botão Consulta'
  },
  search: {
    zh: '查询',
    en: '',
    pu: 'Consultar'
  },
  reset: {
    zh: '重置',
    en: 'reset',
    pu: 'Resetar'
  },
  add: {
    zh: '新增',
    en: 'add',
    pu: 'Novo'
  },
  Delete: {
    zh: '删除',
    en: 'Delete',
    pu: 'Excluir'
  },
  download: {
    zh: '用户导出',
    en: '',
    pu: 'Exportação do usuário'
  },
  userStop: {
    zh: '账号停用',
    en: '',
    pu: 'Desativar a conta'
  },
  userStart: {
    zh: '账号启用',
    en: '',
    pu: 'Ativar a conta'
  },
  ind: {
    zh: '序号',
    en: 'index',
    pu: 'Número de série.'
  },
  englishName: {
    zh: '英文名称',
    en: '',
    pu: 'nome em inglês'
  },
  organizationName: {
    zh: '所属部门',
    en: '',
    pu: 'departamento'
  },
  AccountStatus: {
    zh: '账户状态',
    en: 'Account status',
    pu: 'Status da Conta'
  },
  permissionType: {
    zh: '账户权限状态',
    en: '',
    pu: 'Status de permissão de conta'
  },
  normal: {
    zh: '正常',
    en: 'normal',
    pu: 'normal'
  },
  personality: {
    zh: '个性化',
    en: 'personalized',
    pu: 'personalizado'
  },
  unauthorized: {
    zh: '未授权',
    en: 'unauthorized',
    pu: 'não autorizado'
  },
  createTime: {
    zh: '创建日期',
    en: '',
    pu: 'Data de criação'
  },
  creator: {
    zh: '创建人',
    en: 'creator',
    pu: 'Criado por'
  },
  operation: {
    zh: '操作',
    en: 'operation',
    pu: 'Operação'
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
    pu: 'editar'
  },
  authorization: {
    zh: '授权',
    en: '',
    pu: 'autorizar'
  },
  resetPasswordL: {
    zh: '重置密码：',
    en: 'reset password：',
    pu: 'redefinir a senha：'
  },
  resetPassword: {
    zh: '重置密码',
    en: 'reset password',
    pu: 'Redefinir a senha'
  },
  newPassword: {
    zh: '新密码',
    en: 'new password',
    pu: 'nova senha'
  },
  requestedInputCode: {
    zh: '请按照要求输入密码',
    en: 'Please enter the password as required',
    pu: 'Por favor digitar a senha conforme requerido'
  },
  checkPwd: {
    zh: '确认密码',
    en: 'Confirm password',
    pu: 'Confirmar senha'
  },
  inputConfirmCode: {
    zh: '请输入确认密码',
    en: 'Please confirm your password',
    pu: 'Introduza a senha de confirmação, por favor'
  },
  checkPwdNotNewPwd: {
    zh: '确认密码与新密码不相同',
    en: '',
    pu: 'a senha de confirmação não é a mesma que a nova senha'
  },
  SelectPerson: {
    zh: '请选择要发送消息的人员',
    en: '',
    pu: 'Favor selecionar a pessoa para quem você deseja enviar a mensagem'
  },
  addUser: {
    zh: '添加用户',
    en: '',
    pu: 'Adicionar usuário'
  },
  editUser: {
    zh: '编辑用户',
    en: '',
    pu: 'Editar usuário'
  },
  rightChoiceData: {
    zh: '请正确选择需要操作的数据!',
    en: '',
    pu: 'Por favor, selecione corretamente os dados a serem manipulados!'
  },
  selectData: {
    zh: '请选择需要操作的数据!',
    en: '',
    pu: 'Por favor, selecione os dados a serem manipulados!'
  },
  selectDataError: {
    zh: '选择数据用户状态不正确,请重新勾选!',
    en: '',
    pu: 'A seleção o status de usuário dos dados está incorreta, por favor selecione novamente!'
  },
  enableUser: {
    zh: '是否启用用户账户?',
    en: '',
    pu: 'ativar a conta do usuário?'
  },
  disableUser: {
    zh: '是否停用用户账户?',
    en: '',
    pu: 'desativar a conta do usuário?'
  },
  tips: {
    zh: '提示',
    en: 'tips',
    pu: 'Dica'
  },
  confirm: {
    zh: '确定',
    en: 'determine',
    pu: 'Confirmar'
  },
  cancel: {
    zh: '取消',
    en: 'cancel',
    pu: 'Cancelar'
  },
  TheOperationSucceeded: {
    zh: '操作成功!',
    en: 'The operation succeeded!',
    pu: 'A operação foi bem sucedida.'
  },
  operationCancel: {
    zh: '操作取消',
    en: '',
    pu: 'A operação foi cancelada.'
  },
  authorizationOperationSucceeded: {
    zh: '授权操作成功!',
    en: '',
    pu: 'Operação autorizada com sucesso!'
  },
  succeed: {
    zh: '成功',
    en: 'succeed',
    pu: 'suceder'
  },
  resetSucceeded: {
    zh: '重置成功',
    en: '',
    pu: 'redefinir com sucesso'
  },
  chooseExportUser: {
    zh: '请选择需要导出的用户',
    en: '',
    pu: 'Favor selecionar o usuário para o qual você deseja exportar'
  },
  ExportSuccessful: {
    zh: '导出成功，数据将会在1~10分钟内生成表格，请到系统管理中的资源导出列表中下载，',
    en: 'If the export is successful, the data will be generated within 1~10 minutes, please download it from the resource export list in system management.',
    pu: 'Se a exportação for bem sucedida, os dados serão gerados dentro de 1~10 minutos, por favor, baixe-os da lista de exportação de recursos no gerenciamento do sistema.'
  },
  notRepeatTheExport: {
    zh: '请勿重复导出',
    en: 'Do not repeat the export！',
    pu: 'Não repita a exportação！'
  },
  GoNow: {
    zh: '立即前往',
    en: 'Go now',
    pu: 'Vá agora.'
  },
  ShutDown: {
    zh: '关闭',
    en: 'Shut down',
    pu: 'Desligar'
  },
  basicInformation: {
    zh: '基本信息',
    en: '',
    pu: 'Informações básicas'
  },
  usernameL: {
    zh: '账号：',
    en: '',
    pu: 'número da conta：'
  },
  usernameId: {
    zh: '账号ID',
    en: '',
    pu: 'Número da conta ID'
  },
  userPhoneL: {
    zh: '电话：',
    en: 'Phone：',
    pu: 'Telefone：'
  },
  realNameL: {
    zh: '真实姓名：',
    en: '',
    pu: 'nome real：'
  },
  password: {
    zh: '密码：',
    en: '',
    pu: 'Senha：'
  },
  EnglishName: {
    zh: '英文名：',
    en: 'English name：',
    pu: 'Nome em inglês：'
  },
  PlatformWhichBelongs: {
    zh: '所属平台：',
    en: 'The platform to which it belongs：',
    pu: 'A plataforma à qual pertence：'
  },
  orgCode: {
    zh: '组织机构：',
    en: '',
    pu: 'Organização：'
  },
  hasAudit: {
    zh: '是否为审核人：',
    en: '',
    pu: 'É o revisor：'
  },
  Yes: {
    zh: '是',
    en: 'Yes',
    pu: 'sim'
  },
  No: {
    zh: '否',
    en: 'No',
    pu: 'não'
  },
  roles: {
    zh: '用户角色：',
    en: '',
    pu: 'Papel do usuário：'
  },
  userAccountStatus: {
    zh: '账户状态：',
    en: 'Account status：',
    pu: 'Status da Conta：'
  },
  position: {
    zh: '职位：',
    en: '',
    pu: 'Posição：'
  },
  pleaseChoose: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Favor selecionar'
  },
  pleaseInput: {
    zh: '请输入',
    en: 'Please enter the content',
    pu: 'por favor digite'
  },
  code: {
    zh: '员工编号：',
    en: '',
    pu: 'número do funcionário：'
  },
  userState: {
    zh: '用户状态：',
    en: '',
    pu: 'status do usuário：'
  },
  onJob: {
    zh: '在职',
    en: '',
    pu: 'no trabalho'
  },
  leaveJob: {
    zh: '离职',
    en: '',
    pu: 'sem trabalho'
  },
  vacation: {
    zh: '休假',
    en: '',
    pu: 'Licença de ausência'
  },
  entryTime: {
    zh: '入职日期:',
    en: '',
    pu: 'data de entrada:'
  },
  entryTime1: {
    zh: '入职日期',
    en: '',
    pu: 'data de entrada'
  },
  avatar: {
    zh: '头像:',
    en: '',
    pu: 'foto de perfil:'
  },
  resume: {
    zh: '简历:',
    en: '',
    pu: 'CV：'
  },
  onlyPDFnoMore2M: {
    zh: '只能上传PDF文件，且不超过2M',
    en: '',
    pu: 'Carregar somente arquivos em PDF e não maior que 2M'
  },
  remark: {
    zh: '备注：',
    en: 'remark：',
    pu: 'Observação：'
  },
  Next: {
    zh: '下一步',
    en: 'Next',
    pu: 'Próximo'
  },
  additionalInformation: {
    zh: '附加信息',
    en: '',
    pu: 'Informações adicionais'
  },
  identityCard: {
    zh: '身份证:',
    en: 'identityCard:',
    pu: 'bilhete de identidade:'
  },
  birthday: {
    zh: '生日:',
    en: '',
    pu: 'aniversário:'
  },
  birthday1: {
    zh: '生日',
    en: '',
    pu: 'aniversário'
  },
  gender: {
    zh: '性别:',
    en: '',
    pu: 'Gênero:'
  },
  gender1: {
    zh: '性别',
    en: '',
    pu: 'Gênero'
  },
  male: {
    zh: '男',
    en: '',
    pu: 'masculino'
  },
  female: {
    zh: '女',
    en: '',
    pu: 'feminino'
  },
  educationBackground: {
    zh: '学历:',
    en: '',
    pu: 'qualificações acadêmicas：'
  },
  primarySchool: {
    zh: '小学',
    en: '',
    pu: 'ensino primário'
  },
  juniorHighSchool: {
    zh: '初中',
    en: '',
    pu: 'ensino secundário'
  },
  highSchool: {
    zh: '高中',
    en: '',
    pu: 'ensino médio'
  },
  college: {
    zh: '大专',
    en: '',
    pu: 'colégio júnior'
  },
  undergraduateCourse: {
    zh: '本科',
    en: '',
    pu: 'licenciatura'
  },
  master: {
    zh: '硕士',
    en: '',
    pu: 'mestrado'
  },
  doctor: {
    zh: '博士',
    en: '',
    pu: 'doutoramento'
  },
  socialSecurity: {
    zh: '社保:',
    en: '',
    pu: 'seguridade social：'
  },
  accumulationFund: {
    zh: '公积金:',
    en: '',
    pu: 'fundo de previdência habitacional:'
  },
  QQ: {
    zh: 'QQ:',
    en: '',
    pu: 'QQ:'
  },
  dingding: {
    zh: '钉钉:',
    en: '',
    pu: 'DingDing:'
  },
  termDate: {
    zh: '离职日期:',
    en: '',
    pu: 'data de saída:'
  },
  weixin: {
    zh: '微信:',
    en: '',
    pu: 'WeChat:'
  },
  email: {
    zh: '邮箱：',
    en: 'mailbox',
    pu: 'correio electrônico/email：'
  },
  email1: {
    zh: '邮箱',
    en: 'mailbox',
    pu: 'correio electrônico/email'
  },
  weibo: {
    zh: '微博:',
    en: '',
    pu: 'WeiBo:'
  },
  emergencyContact: {
    zh: '紧急联系人:',
    en: '',
    pu: 'contacto de emergência:'
  },
  emergencyTelephoneNumber: {
    zh: '紧急联系电话:',
    en: '',
    pu: 'contacto de emergência:'
  },
  address: {
    zh: '住址:',
    en: '',
    pu: 'endereço:'
  },
  Previous: {
    zh: '上一步',
    en: 'Previous',
    pu: 'Anterior'
  },
  inputName: {
    zh: '请填写账户名',
    en: '',
    pu: 'Favor preencher o nome de sua conta'
  },
  nameIsLetterOrSumber: {
    zh: '账号必须为字母或者数字',
    en: '',
    pu: 'O número da conta deve ser alfanumérico ou numérico'
  },
  longIs5To15: {
    zh: '长度在 5 到 15 个字符',
    en: '',
    pu: 'Comprimento entre 5 e 15 caracteres'
  },
  nameRepeat: {
    zh: '用户名重复,请重新填写',
    en: '',
    pu: 'nome de usuário repetido, por favor preencha novamente'
  },
  longIs2To30: {
    zh: '长度在 2 到 100 个字符',
    en: '',
    pu: 'Comprimento entre 2 e 100 caracteres'
  },
  inputRealName: {
    zh: '请填写用户真实姓名',
    en: '',
    pu: 'Por favor, preencha nome real do usuário'
  },
  ChooseUserState: {
    zh: '请选择用户状态',
    en: '',
    pu: 'Por favor, selecione o status do usuário'
  },
  inputPWD: {
    zh: '请填写密码',
    en: '',
    pu: 'Favor preencher a senha'
  },
  pwdNotChineses: {
    zh: '密码不能有中文字符.',
    en: '',
    pu: 'A senha não pode ter caracteres chineses.'
  },
  pwdNotEmoji: {
    zh: '密码不能使用表情.',
    en: '',
    pu: 'As senhas não podem usar emoji.'
  },
  passwordPrompt: {
    zh: '密码必须由 8-12位字母、数字组成，可选特殊符号.',
    en: '',
    pu: 'A senha deve ser composta de 8-12 letras e números, com a opção de símbolos especiais.'
  },
  defaultPassword: {
    zh: '默认密码',
    en: '',
    pu: 'senha padrão'
  },
  inputPwdAgian: {
    zh: '请再次输入新密码',
    en: '',
    pu: 'Favor digitar nova senha novamente'
  },
  chooseAccountState: {
    zh: '请选择账户状态',
    en: '',
    pu: 'Favor selecionar o status da conta'
  },
  chooseOrgCode: {
    zh: '请选择用户组织架构',
    en: '',
    pu: 'Por favor, selecione a organização do usuário'
  },
  choosePosition: {
    zh: '请选择职位',
    en: '',
    pu: 'Por favor, selecione uma posição'
  },
  chooseRoles: {
    zh: '请选择用户角色',
    en: '',
    pu: 'Favor selecionar o papel do usuário'
  },
  chooseEntryTime: {
    zh: '请选择用户入职日期',
    en: '',
    pu: 'Favor selecionar a data de entrada do usuário'
  },
  chooseQQ: {
    zh: 'QQ长度不合法',
    en: '',
    pu: 'O comprimento QQ não é legal'
  },
  emailNotFormat: {
    zh: '邮箱格式不正确',
    en: '',
    pu: 'Formato de e-mail incorreto'
  },
  inputIdcard: {
    zh: '请输入身份证',
    en: '',
    pu: 'Por favor, digite seu número de identificação'
  },
  chooseSex: {
    zh: '请选择性别',
    en: '',
    pu: 'Por favor, selecione um gênero'
  },
  inputEmergencyContact: {
    zh: '请输入紧急联系人',
    en: '',
    pu: 'Favor digitar um contato de emergência'
  },
  inputPhone: {
    zh: '请填写联系电话',
    en: '',
    pu: 'Favor preencher o número de contato'
  },
  warning: {
    zh: '警告',
    en: '',
    pu: 'aviso'
  },
  warningContent: {
    zh: '当前部门下暂无职位，如需添加请前往《用户中心-职务管理》添加',
    en: '',
    pu: 'Não há empregos no departamento atual, se você quiser adicionar um, vá ao "Centro do Usuário - Gerenciamento de empregos" para adicionar um.'
  },
  onlyJPG: {
    zh: '上传头像图片只能是 JPG 格式!',
    en: '',
    pu: 'imagem carregada de foto de perfil somente em formato JPG!'
  },
  imgNoMore2MB: {
    zh: '上传头像图片大小不能超过 2MB!',
    en: '',
    pu: 'imagem carregada de foto de perfil não maior que 2MB!'
  },
  nolyPDF: {
    zh: '上传简历只能是 PDF 格式!',
    en: '',
    pu: 'Faça o upload de seu CV somente em formato PDF!'
  },
  test5: {
    zh: '上传简历大小不能超过 2MB!',
    en: '',
    pu: 'O tamanho do upload de seu CV não deve exceder 2MB!'
  },
  userSetPermission: {
    zh: '用户授权',
    en: '',
    pu: 'Autorização do usuário'
  },
  notNull: {
    zh: '不能为空',
    en: 'Cannot be empty',
    pu: 'Não pode estar vazio'
  },
  longIs: {
    zh: '长度在',
    en: '',
    pu: 'Comprimento entre'
  },
  longTo: {
    zh: '到',
    en: '',
    pu: 'e'
  },
  longCode: {
    zh: ' 个字符',
    en: '',
    pu: 'caracteres'
  },
  dot: {
    zh: '网点：',
    en: '',
    pu: 'Ponto：'
  },
  useRange: {
    zh: '使用范围：',
    en: '',
    pu: 'Âmbito de utilização.：'
  },
  userCategory: {
    zh: '用户类别：',
    en: '',
    pu: 'Categoria do utilizador.：'
  },
  onlyDotUse: {
    zh: '仅在网点使用',
    en: '',
    pu: 'Para utilização apenas em Pontos'
  },
  codeUse: {
    zh: '员工编号可用',
    en: '',
    pu: 'Número de funcionários disponível'
  },
  codeRepeat: {
    zh: '员工编号重复，不可用',
    en: '',
    pu: 'Número de funcionários em duplicado, não disponível'
  },
  ModifyThePerson: {
    zh: '修改人',
    en: 'Modify the person',
    pu: 'Pessoa de modificação'
  },
  ModificationTime: {
    zh: '修改时间',
    en: 'Modification time',
    pu: 'Tempo de modificação'
  },
  updateUserBelongs: {
    zh: '修改人所属网点',
    en: '',
    pu: 'Ponto de modificador'
  },
  business: {
    zh: '业务范围：',
    en: '',
    pu: 'Âmbito de negócios：'
  },
  business1: {
    zh: '因邮编不连续，如出现多个同名州、城市，请同时勾选',
    en: '',
    pu: 'Devido à falta de continuidade nos códigos postais, ao encontrar vários municípios e estados com o mesmo nome, por favor, selecione-os simultaneamente'
  },
  temporaryWorker: {
    zh: '临时工',
    en: '',
    pu: 'Diarista'
  },
  deliveryRider: {
    zh: '骑手',
    en: '',
    pu: 'Motorista'
  },
  courier: {
    zh: '快递员',
    en: '',
    pu: 'Entregador'
  },
  workLocation: {
    zh: '工作地点',
    en: '',
    pu: 'Local de trabalho'
  },
  warehouse1: {
    zh: '1号仓库',
    en: '',
    pu: 'Armazém 1'
  },
  warehouse2: {
    zh: '2号仓库',
    en: '',
    pu: 'Armazém 2'
  },
  pleaseEnterYourIdNumber: {
    zh: '请输入编号',
    en: '',
    pu: 'Favor digitar o código'
  },
  onboarding: {
    zh: '入职',
    en: '',
    pu: 'Integração'
  },
  evaluation: {
    zh: '评价',
    en: '',
    pu: 'Avaliação'
  },
  age: {
    zh: '年龄',
    en: '',
    pu: 'Idade'
  },
  latestHiringDate: {
    zh: '最新入职时间',
    en: '',
    pu: 'Data da integração mais recente'
  },
  latestDepartureDate: {
    zh: '最新离职时间',
    en: '',
    pu: 'Data de separação mais recente'
  },
  latestIntegrityLevel: {
    zh: '最新诚信等级',
    en: '',
    pu: 'Nível de integridade mais recente'
  },
  viewEdit: {
    zh: '查看/编辑',
    en: '',
    pu: 'Exibir/Editar'
  },
  detailedAddress: {
    zh: '详细住址',
    en: '',
    pu: 'Endereço completo'
  },
  workRecord: {
    zh: '工作记录',
    en: '',
    pu: 'Registro de trabalho'
  },
  node: {
    zh: '节点',
    en: '',
    pu: 'Nó'
  },
  evaluationRecord: {
    zh: '评价记录',
    en: '',
    pu: 'Registro de avaliação'
  },
  evaluationLevel: {
    zh: '评价等级',
    en: '',
    pu: 'Nível de avaliação'
  },
  employeeEvaluation: {
    zh: '员工评价',
    en: '',
    pu: 'Avaliação de funcionário'
  },
  upTo500ID: {
    zh: '最多支持500个编号查询',
    en: '',
    pu: 'Suporta até 500 pesquisas de códigos'
  },
  thisOperation: {
    zh: '是否继续此操作？',
    en: '',
    pu: 'Se deve continuar essa operação'
  },
  employeeToEvaluate: {
    zh: '请选择一个员工进行评价',
    en: '',
    pu: 'Selecione um funcionário para avaliar'
  },
  pleaseSelectevaluationLevel: {
    zh: '请选择评价等级',
    en: '',
    pu: 'Selecione o nível de avaliação'
  },
  pleaseEnterEvaluationContent: {
    zh: '请输入评价内容',
    en: '',
    pu: 'Digite sua avaliação'
  },
  evaluationSuccessful: {
    zh: '评价成功',
    en: '',
    pu: 'Avaliação do sucesso'
  },
  importTemplate: {
    zh: '人员登记导入模板',
    en: '',
    pu: 'Modelo de importação de registro de pessoal'
  },
  ImportDataIsEmpty: {
    zh: '导入数据为空',
    en: '',
    pu: 'Os dados de importação estão vazios'
  },
  pleaseCheck: {
    zh: '填写有误，请检查',
    en: '',
    pu: 'Preenchido incorretamente, favor verificar'
  },
  failedToImport: {
    zh: '导入失败人员列表',
    en: '',
    pu: 'Falha ao importar a lista de pessoal'
  },
  exceedsLengthLimit: {
    zh: '超出长度限制',
    en: '',
    pu: 'Excede o limite de comprimento'
  },
  time: {
    zh: '时间',
    en: '',
    pu: 'Tempo de'
  },
  provider: {
    zh: '服务商',
    en: '',
    pu: 'Parceiro'
  },
  permission: {
    zh: '权限',
    en: 'Permission',
    pu: 'Permissão'
  },
  LoginAccount: {
    zh: '登录账号',
    en: 'Login account',
    pu: 'Iniciar sessão na conta'
  },
  effective: {
    zh: '有效',
    en: 'effective',
    pu: 'eficaz'
  },
  expiringSoon: {
    zh: '即将到期',
    en: 'expiring soon',
    pu: 'Prestes a expirar'
  },
  expired: {
    zh: '已到期',
    en: 'expired',
    pu: 'Vencido'
  },
  CreateNewTemporaryWorkerAccount: {
    zh: '新建临时工账号',
    en: 'Create a new temporary worker account',
    pu: 'Crie uma conta temporária'
  },
  dataValidation: {
    zh: '数据校验',
    en: 'data validation',
    pu: 'Validação de Dados'
  },
  CreationCompleted: {
    zh: '创建完成',
    en: 'Creation completed',
    pu: 'Criação concluída'
  },
  SupportsXlsxXlsFiles: {
    zh: '支持 .xlsx / .xls，单次最多 100 人，文件大小不超过 10MB',
    en: 'Supports .xlsx / .xls files, with a maximum of 100 people per submission, and a file size not exceeding 10MB',
    pu: 'Suporta .xlsx / .xls, até 100 pessoas por vez, tamanho do arquivo não superior a 10MB'
  },
  DownloadExcelTemplate: {
    zh: '下载Excel模板',
    en: 'Download Excel template',
    pu: 'Baixar modelo do Excel'
  },
  AccountValidityPeriod: {
    zh: '账号有效期',
    en: 'Account Validity Period',
    pu: 'Validade da conta'
  },
  TemporaryWorkerAccountImport: {
    zh: '临时工账号导入',
    en: 'Temporary worker account import',
    pu: 'Importação de contas de trabalhadores temporários'
  },
  OnlyOneFileCanBeUploaded: {
    zh: '只能上传一个文件',
    en: 'Only one file can be uploaded',
    pu: 'Só pode carregar um ficheiro'
  },
  Reapply: {
    zh: '重新申请',
    en: 'Reapply',
    pu: 'Reaplicar'
  },
  ReturnListTemporaryWorkerAccounts: {
    zh: '返回临时工账号列表',
    en: 'Return to the list of temporary worker accounts',
    pu: 'Voltar à lista de contas temporárias'
  },
  CreateTemporaryWorkerAccountsBulk: {
    zh: '批量创建临时工账号',
    en: 'Create temporary worker accounts in bulk',
    pu: 'Criação em lote de contas de trabalhadores temporários'
  },
  ImportAndCreateTemporaryWorkerAccounts: {
    zh: '通过 Excel 批量导入并创建当前 HUB 的临时工账号',
    en: 'Import and create temporary worker accounts for the current HUB in bulk through Excel',
    pu: 'Importação em lote de contas temporárias de trabalhadores do HUB atual por meio do Excel'
  },
  AccountCreationSuccessful: {
    zh: '账号创建成功',
    en: 'Account creation successful',
    pu: 'A conta foi criada com sucesso'
  },
  PleaseExportTheLoginAccountAndInitialPasswordCreatedThisTimeImmediately: {
    zh: '请立即导出本次创建的登录账号和初始密码',
    en: 'Please export the login account and initial password created this time immediately',
    pu: 'Exporte agora mesmo o login e a senha inicial criados nesta sessão'
  },
  temporaryWorkerAccountsHaveBeenSuccessfullyCreated: {
    zh: '个临时工账号创建成功',
    en: ' temporary worker accounts have been successfully created',
    pu: ' contas temporárias criadas com sucesso'
  },
  TheAccountHasBeenCreatedAndWillTakeEffectImmediately: {
    zh: '账号已创建并立即生效，将按照各自设置的有效天数自动失效。',
    en: 'The account has been created and will take effect immediately. It will automatically expire according to the effective days set for each account.',
    pu: 'A conta foi criada e está ativa imediatamente, e expira automaticamente de acordo com o número de dias eficazes estabelecidos para cada um.'
  },
  TheAccountAndInitialPasswordCanOnlyBeViewedAndExportedThisTime: {
    zh: '账号和初始密码仅本次可查看和导出',
    en: 'The account and initial password can only be viewed and exported this time',
    pu: 'conta e a senha inicial podem ser visualizados e exportados apenas nessa'
  },
  ForAccountSecurity: {
    zh: '为了账号安全，离开本页面后系统将不再展示本批次的初始密码。后续如忘记密码，只能通过“重置密码”重新生成。',
    en: 'For account security, the system will no longer display the initial password of this batch after leaving this page. If you forget your password in the future, you can only reset it through the "Reset Password" option.',
    pu: 'Para a segurança da conta, após deixar esta página, o sistema não mostrará mais a senha inicial deste lote. Posteriormente, caso esqueça a senha, só poderá gerar uma nova senha através da opção “Reiniciar senha”.'
  },
  CreateBatch: {
    zh: '创建批次',
    en: 'Create Batch',
    pu: 'Criar lote'
  },
  NumberOfAccountsCreated: {
    zh: '创建账号数',
    en: 'Number of accounts created',
    pu: 'Número de contas criadas'
  },
  PreviewOfTheCreationResult: {
    zh: '本次创建结果预览',
    en: 'Preview of the creation result',
    pu: 'Visualização dos resultados da criação'
  },
  InitialPassword: {
    zh: '初始密码',
    en: 'Initial password',
    pu: 'Senha inicial'
  },
  NumberOfDaysTheAccountIsValid: {
    zh: '账号有效天数',
    en: 'Number of days the account is valid',
    pu: 'Número de dias de validade da conta'
  },
  ATotalOf: {
    zh: '共',
    en: 'A total of',
    pu: 'Total de'
  },
  items: {
    zh: '条',
    en: 'items',
    pu: 'itens'
  },
  ThisPageOnlyDisplaysSomeExamples: {
    zh: '本页面仅展示部分示例',
    en: 'This page only displays some examples',
    pu: 'Esta página só mostra alguns exemplos'
  },
  ExportAccountAndPassword: {
    zh: '导出账号和密码',
    en: 'Export account and password',
    pu: 'Exportar conta e senha'
  },
  TheExportedExcelFileWillInclude: {
    zh: '导出的 Excel 将包含：姓名、CPF、所属转运中心、登录账号、初始密码、岗位、账号有效天数、创建人、创建时间。请仅提供给有权限的现场负责人。',
    en: 'O Excel exportado conterá: Nome, CPF, Centro de Transferência, Login, Senha Inicial, Cargo, Dias de Validade da conta, Criado por, Data de criação. Fornecer somente aos responsáveis do local autorizados.',
    pu: 'O Excel exportado conterá: Nome, CPF, Centro de Transferência, Login, Senha Inicial, Cargo, Dias de Validade da conta, Criado por, Data de criação. Fornecer somente aos responsáveis do local autorizados.'
  },
  ExportAccountAndPasswordAtOnce: {
    zh: '一次性导出账号和密码',
    en: 'Export account and password at once',
    pu: 'Exportar de uma só vez as contas e senhas'
  },
  recommendedConfirmThatTheExportHasBeenSuccessfulBeforeLeavingThisPage: {
    zh: '建议确认导出成功后再离开本页面。',
    en: 'It is recommended to confirm that the export has been successful before leaving this page.',
    pu: 'Recomendamos que confirme que a exportação foi bem sucedida antes de sair desta página.'
  },
  CompleteAndReturnTheAccountList: {
    zh: '完成并返回账号列表',
    en: 'Complete and return the account list',
    pu: 'Conclua e volte à lista de contas'
  },
  AccountDataVerificationResult: {
    zh: '账号数据校验结果',
    en: 'Account data verification result',
    pu: 'Resultado da validação de dados da conta'
  },
  TheSystemHasCompletedParsingExcelData: {
    zh: '系统已完成 Excel 数据解析，并对人员身份、重复账号、岗位、账号时效等规则进行校验。',
    en: 'The system has completed Excel data parsing and verified rules such as personnel identity, duplicate accounts, positions, and account timeliness.',
    pu: 'O sistema já realizou a análise dos dados do Excel e validou as regras para identificação dos funcionários, contas duplicadas, cargos, vigência das contas e etc.'
  },
  TotalImports: {
    zh: '导入总数',
    en: 'Total imports',
    pu: 'Importação total'
  },
  VerificationPassed: {
    zh: '校验通过',
    en: 'Verification passed',
    pu: 'Verificação aprovada'
  },
  VerificationFailed: {
    zh: '校验失败',
    en: 'Verification failed',
    pu: 'Falha na verificação'
  },
  VerificationResult: {
    zh: '校验结果',
    en: 'Verification Result',
    pu: 'Resultado da verificação'
  },
  dataHaveFailedVerification: {
    zh: '数据未通过校验。你可以下载错误明细后修改 Excel 并重新上传，也可以仅继续创建已通过校验的',
    en: ' of data have failed verification. You can either download the error details, modify the Excel file, and re-upload it, or simply proceed to create the',
    pu: ' dados que não passaram na validação. Você pode baixar o detalhamento dos erros, editar o Excel e reenviá-lo, ou apenas continuar criando as'
  },
  accountsThatHavePassedVerification: {
    zh: '个账号。',
    en: 'accounts that have passed verification.',
    pu: 'contas que passaram na validação.'
  },
  DataThatFailedVerification: {
    zh: '校验未通过数据',
    en: 'Data that failed verification',
    pu: 'dados que não passaram na validação'
  },
  DownloadErrorDetails: {
    zh: '下载错误明细',
    en: 'Download error details',
    pu: 'Download do detalhamento dos erros'
  },
  lineNumber: {
    zh: 'Excel 行号',
    en: 'Excel row number',
    pu: 'Número da linha do Excel'
  },
  PleaseCheckTheConfirmationBoxBeforeContinuingToCreateCnAccount: {
    zh: '请先勾选确认后再继续创建账号',
    en: 'Please check the confirmation box before continuing to create an account',
    pu: 'Marque a caixa de confirmação e continue com a criação da conta'
  },
  IHaveConfirmedThatOnlyThe: {
    zh: '我已确认本次将仅创建校验通过的 ',
    en: 'I have confirmed that only the ',
    pu: 'Já confirmei que desta vez serão criadas apenas '
  },
  accountsThatHavePassedVerificationWill: {
    zh: ' 个账号，校验失败的 ',
    en: ' accounts that have passed verification will be created this time, and the ',
    pu: ' perfis validados, não serão criados os '
  },
  piecesOfDataThatFailed: {
    zh: ' 条数据不会创建。',
    en: ' pieces of data that failed verification will not be created.',
    pu: ' perfis que não foram validados.'
  },
  ReUploadExcel: {
    zh: '重新上传 Excel',
    en: 'Re-upload Excel',
    pu: 'Carregar novamente o Excel'
  },
  UploadAndVerify: {
    zh: '上传并校验',
    en: 'Upload and verify',
    pu: 'Carregar e verificar'
  },
  AccountValidity: {
    zh: '账号时效',
    en: 'Account Validity',
    pu: 'Validade da conta'
  },
  TheNumberOfDaysTheAccount: {
    zh: '每条临时工数据必须填写账号有效天数。账号达到失效时间后自动禁止登录，如需继续使用必须重新申请。',
    en: 'The number of days the account is valid must be filled in for each piece of temporary worker data. Once the account reaches its expiration date, it will automatically be disabled from login. If continued use is required, a new application must be submitted.',
    pu: 'Cada registro de temporário deve conter o número de dias de validade da conta. Quando a conta atingir o tempo de expiração, será automaticamente desabilitada para login, caso queira continuar usando, deve solicitar novamente.'
  },
  ExcelRequiredFields: {
    zh: 'Excel 必填字段',
    en: 'Excel Required Fields',
    pu: 'Campo obrigatório do Excel'
  },
  AffiliatedTransferCenter: {
    zh: '“所属转运中心”需要在 Excel 中填写，系统会校验当前创建人是否拥有对应转运中心的账号创建权限。',
    en: '"Affiliated Transfer Center" needs to be filled in Excel, and the system will verify whether the current creator has the account creation permission for the corresponding transfer center.',
    pu: '"Centro de Transferência Atribuído" precisa ser preenchido no Excel, o sistema irá validar se o criador atual possui permissão para criar conta no Centro de Transferência correspondente.'
  },
  dataPoints: {
    zh: ' 条数据',
    en: ' data points',
    pu: ' dados'
  },
  UploadTheListOfTemporaryWorkers: {
    zh: '上传临时工名单',
    en: 'Upload the list of temporary workers',
    pu: 'Carregar lista de temporários'
  },
  PleaseDownloadTheStandardTemplateFirst: {
    zh: '上传临时工名单',
    en: 'Please download the standard template first, fill it out, and then upload it. Do not modify the header names or field order.',
    pu: 'Por favor, faça o download do modelo padrão, preencha-o e carregue-o depois. Não altere os nomes dos cabeçalhos ou a ordem dos campos.'
  },
  NoSuccessfullyVerifiedData: {
    zh: '没有校验成功的数据可创建',
    en: 'No successfully verified data can be created, please upload again',
    pu: 'Não há dados validados para criar, faça o upload novamente'
  },
  Create: {
    zh: '创建 ',
    en: 'Create ',
    pu: 'criação de '
  },
  accounts: {
    zh: ' 个账号',
    en: ' accounts',
    pu: ' contas'
  },
  ConfirmAndReturnToAccountList: {
    zh: '确认返回账号列表',
    en: 'Confirm and return to account list',
    pu: 'Confirmar retorno para a lista de contas'
  },
  StillReturn: {
    zh: '仍然返回',
    en: 'Still return',
    pu: 'Ainda retorna'
  },
  TheAccountsAndInitialPasswords: {
    zh: '本批次账号和初始密码尚未导出',
    en: 'The accounts and initial passwords for this batch have not been exported yet',
    pu: 'As contas e senhas iniciais deste lote ainda não foram exportadas'
  },
  AfterLeavingThisPage: {
    zh: '离开本页面后，系统将不再展示本次生成的初始密码。后续只能通过“重置密码”重新生成密码。',
    en: 'After leaving this page, the system will no longer display the initial password generated this time. Subsequently, you can only reset your password through the "Reset Password" option.',
    pu: 'Após sair desta página, o sistema não exibirá mais a senha inicial gerada. Posteriormente, a senha só poderá ser gerada novamente através de “Redefinir Senha”.'
  },
  UponReturning: {
    zh: '返回后将进入「临时工账号管理」列表页。',
    en: 'Upon returning, you will enter the "Temporary Worker Account Management" list page.',
    pu: 'Após o retorno será acessada a página da lista de “Gerenciamento de Contas de Terceirizados”.'
  },
  ViewTemporaryWorkerAccount: {
    zh: '查看临时工账号',
    en: 'View temporary worker account',
    pu: 'Visualizar conta temporária'
  },
  ConfirmReset: {
    zh: '确认重置',
    en: 'Confirm Reset',
    pu: 'Confirmar redefinição'
  },
  Note: {
    zh: '注意',
    en: 'Note',
    pu: 'Atenção'
  },
  AfterResettingOriginalPasswordWillBecomeInvalidImmediately: {
    zh: '重置后原密码将立即失效，系统会生成新的随机密码。临时工下次登录可直接使用新密码。',
    en: 'After resetting, the original password will become invalid immediately, and the system will generate a new random password. The temporary worker can directly use the new password for the next login.',
    pu: 'A senha original será imediatamente invalidada após a reinicialização e o sistema gerará uma nova senha aleatória. A nova senha será diretamente utilizada na próxima vez que o trabalhador temporário fizer login.'
  },
  IConfirmResetThePassword: {
    zh: '我确认需要重置该临时工账号密码。',
    en: 'I confirm that I need to reset the password for this temporary worker account.',
    pu: 'Confirma-se a necessidade de redefinir a password da conta Temp.'
  },
  PleaseCheckTheConfirmation: {
    zh: '我确认需要重置该临时工账号密码。',
    en: 'Please check the confirmation box before resetting your password.',
    pu: 'Por favor, confirme antes de redefinir a sua palavra-passe.'
  },
  AccountOperationRecord: {
    zh: '账号操作记录',
    en: 'Account operation record',
    pu: 'Registro de operações da conta'
  },
  ResetTemporaryWorkerAccountPassword: {
    zh: '重置临时工账号密码',
    en: 'Reset temporary worker account password',
    pu: 'Resetar a senha do usuário temporário'
  },
  PasswordResetSuccessful: {
    zh: '密码重置成功',
    en: 'Password reset successful',
    pu: 'A redefinição da senha foi bem-sucedida'
  },
  TheNewTemporaryPassword: {
    zh: '新的临时密码仅展示本次，请立即提供给对应临时工。',
    en: 'The new temporary password is only displayed this time. Please provide it to the corresponding temporary worker immediately.',
    pu: 'A nova senha temporária é mostrada somente nessa vez, por favor, forneça-a imediatamente ao trabalhador temporário correspondente.'
  },
  NewTemporaryPassword: {
    zh: '新的临时密码',
    en: 'New temporary password',
    pu: 'Uma nova senha temporária'
  },
  CopyPassword: {
    zh: '复制密码',
    en: 'Copy password',
    pu: 'Copiar senha'
  },
  TheNewTemporaryPasswordCan: {
    zh: '该账号下次登录可直接使用新的临时密码。',
    en: 'The new temporary password can be directly used for the next login of this account.',
    pu: 'A próxima vez que o utilizador iniciar sessão poderá utilizar diretamente a nova palavra-passe temporária.'
  },
  ReapplyTemporaryWorkerAccount: {
    zh: '重新申请临时工账号',
    en: 'Reapply for a temporary worker account',
    pu: 'Requisitar novamente conta temporária'
  },
  AccountHasExpired: {
    zh: '账号已到期，需要重新申请新的有效期后才能继续登录',
    en: 'The account has expired and a new one with a valid period needs to be applied for before continuing to log in',
    pu: 'A conta expirou, é necessário solicitar uma nova validade para continuar logado'
  },
  ReapplyForAnAccount: {
    zh: '账号重新申请',
    en: 'Reapply for an account',
    pu: 'Requisição de novo acesso'
  },
  TheBasicPersonnelInformation: {
    zh: '人员基础信息由历史账号自动带入，仅需确认岗位及新的账号有效期。',
    en: 'The basic personnel information is automatically carried over from the previous account, and only the position and the new account validity period need to be confirmed.',
    pu: 'As informações básicas dos funcionários são trazidas automaticamente a partir da conta histórica, bastando confirmar o cargo e a nova validade da conta.'
  },
  TheOriginalAccount: {
    zh: '原账号',
    en: 'The original account',
    pu: 'A conta'
  },
  hasExpired: {
    zh: ' 已于 ',
    en: ' has expired and been automatically deactivated at ',
    pu: 'expirou em'
  },
  AfterTheReapplicationIsApproved: {
    zh: ' 到期并自动停用。 重新申请通过后，系统保留原账号历史操作记录，并建立新的授权周期。',
    en: ' After the reapplication is approved, the system will retain the historical operation records of the original account and establish a new authorization period.',
    pu: ' e foi desativada automaticamente. Após a aprovação da nova solicitação, o sistema mantém o histórico de operações da conta original e cria um novo ciclo de autorização.'
  },
  // 继续参与本周临时卸车作业
  ContinueTempUnloadWork: {
    zh: '继续参与本周临时卸车作业',
    en: 'Continue to participate in this week\'s temporary unloading work',
    pu: 'Continuar a participar no trabalho de descarga temporária desta semana'
  },
  // 重新申请规则（标题）
  ReapplyRules: {
    zh: '重新申请规则',
    en: 'Rules for reapplication',
    pu: 'Regras para nova requisição'
  },
  // 重新申请规则详细说明
  ReapplyRuleDescription: {
    zh: '不直接修改原到期记录。系统会生成一条新的账号授权记录，并根据账号有效天数重新计算失效时间，确保每次临时用工都有独立审批和审计记录。',
    en: 'The original expiration record will not be directly modified. The system will generate a new account authorization record and recalculate the expiration time based on the account\'s valid days, ensuring that each temporary assignment has independent approval and audit records.',
    pu: 'O registo de expiração original não será modificado diretamente. O sistema irá gerar um novo registo de autorização de conta e recalcular o tempo de expiração com base nos dias válidos da conta, garantindo que cada atribuição temporária tenha registos de aprovação e auditoria independentes.'
  },
  // 有效期规则
  ValidityRules: {
    zh: '有效期规则',
    en: 'Validity rules',
    pu: 'Regras de validade'
  },
  // 生效说明
  EffectiveImmediately: {
    zh: '提交成功后立即生效，最长 30 天',
    en: 'Takes effect immediately upon successful submission, maximum 30 days.',
    pu: 'Entra em vigor imediatamente após a submissão bem-sucedida, máximo de 30 dias.'
  },
  SubmitANewApplication: {
    zh: '提交重新申请',
    en: 'Submit a new application',
    pu: 'Submissão de reabertura de pedido'
  },
  TheReapplicationHasBeenSubmitted: {
    zh: '重新申请已提交。账号重新申请成功，有效天数为 ',
    en: 'The reapplication has been submitted. The account has been successfully reapplied for, with a validity period of',
    pu: 'Solicitação de reativação submetida. Sua solicitação de reativação foi aprovada, com validade de'
  },
  days: {
    zh: ' 天',
    en: ' days',
    pu: ' dias'
  },
  PleaseUploadTheFile: {
    zh: '请上传文件',
    en: 'Please upload the file',
    pu: 'Por favor, carregue o ficheiro.'
  },
  TheUploadedFileContentCannotBeEmpty: {
    zh: '上传文件内容不能为空',
    en: 'The uploaded file content cannot be empty',
    pu: 'O conteúdo do arquivo enviado não pode estar vazio'
  },
  ReasonForApplication: {
    zh: '申请原因',
    en: 'Reason for Application',
    pu: 'Razão da aplicação'
  },
  AccountAndPasswordHaveBeenExported: {
    zh: '已导出本批次账号和初始密码',
    en: 'The account numbers and initial passwords for this batch have been exported',
    pu: 'Contas e senhas iniciais deste lote exportados'
  }
};
export { userManage };
